var React = require('react');

function Tag (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.899 15.335L16.649 1.08496C16.079 0.514959 15.2873 0.166626 14.4165 0.166626H3.33317C1.5915 0.166626 0.166504 1.59163 0.166504 3.33329V14.4166C0.166504 15.2875 0.514837 16.0791 1.10067 16.665L15.3507 30.915C15.9207 31.485 16.7123 31.8333 17.5832 31.8333C18.454 31.8333 19.2457 31.485 19.8157 30.8991L30.899 19.8158C31.4848 19.2458 31.8332 18.4541 31.8332 17.5833C31.8332 16.7125 31.469 15.905 30.899 15.335ZM5.70817 8.08329C4.394 8.08329 3.33317 7.02246 3.33317 5.70829C3.33317 4.39413 4.394 3.33329 5.70817 3.33329C7.02234 3.33329 8.08317 4.39413 8.08317 5.70829C8.08317 7.02246 7.02234 8.08329 5.70817 8.08329Z","fill":"#F26347"}));
}

Tag.defaultProps = {"viewBox":"0 0 32 32","fill":"none"};

module.exports = Tag;

Tag.default = Tag;
